export const BUNDLE_ID = "bb5bc7";
export const LOCAL_STORAGE_PREFIX = "UPS_";

export const LOCAL_NEWS_REGION = "news";

export const DEFAULT_PREFERENCES = {
    [LOCAL_NEWS_REGION]: "ottawa",
};

// CMP Didomi personalized content key
export const DIDOMI_PERSONALIZED_CONTENT_ID = "personaliz-rT2hmC9K";
export const DIDOMI_VENDOR_ID = "cbcradio-bBJUEZ8h";
export const ALLOW_PERSONALIZED_CONTENT_DEFAULT = true;
